import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IInitialState, RootState } from '../../../../reduxService';
import { IDynamicProjectOutputData } from '../../../api/IApiResponse';
/* import * as BeMaccaferriCalculationHelper from '../../api/calculation/BeMaccaferriCalculationHelper'; */
/* import { validateProjectBeforeRun } from '../../../utils/utils'; */
import { warning } from '../../../../components/Alert/Alert';
import i18n from '../../../localization';
import { unit } from '../../../enum/project';
import { EConversionSIToImperial, convertTo } from '../../../conversion';
import { roundToTwo, roundNumbers } from '../../../utils/utils';
import BeMaccaferriStoreProvider from '../../../api/store/BeMaccaferriStoreProvider';

export interface IProjectDynamicValidation {
    startValidation: boolean;
    load: boolean;
    static: boolean;
    errors?: any; // Add this line to include errors in the interface
}

export interface IProjectDynamicResults {
    outputData?: IDynamicProjectOutputData; // Updated to use the new structure
    validation?: IProjectDynamicValidation;
}

const initialState: IInitialState<IProjectDynamicResults> = {
    initialState: true,
};

export const resultsSlice = createSlice({
    name: 'resultsDynamic',
    initialState,
    reducers: {
        cleanResults: state => {
            state.initialState = true;
            state.data = undefined;
        },
        setOutputData: (state, action: PayloadAction<IDynamicProjectOutputData>) => {
            // Apply decimal limitation but preserve precision for Railway designSummary values
            let roundedOutputData = roundNumbers(action.payload);

            // Special handling for Railway data: preserve exact designSummary values from backend
            if (action.payload && typeof action.payload === 'object' && 'designSummary' in action.payload) {
                roundedOutputData = {
                    ...roundedOutputData,
                    designSummary: (action.payload as any).designSummary, // Preserve original precise values
                } as IDynamicProjectOutputData;
            }

            // Payload is now the new structure with precision-preserved designSummary
            state.initialState = false;
            state.data = { ...state.data, outputData: roundedOutputData };
        },
        updateValidation: (state, action: PayloadAction<IProjectDynamicValidation>) => {
            state.initialState = false;
            state.data = { ...state.data, validation: action.payload };
        },
    },
});

export const { cleanResults, setOutputData, updateValidation } = resultsSlice.actions;

export default resultsSlice.reducer;
